import React, { useState } from 'react'
import { connect } from "react-redux";
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useForm } from "react-hook-form";

// components
import SelectGeneric from "../../select/selectGeneric";
import { ButtonCancel, ButtonSubmit } from "../../buttons/buttonsActions";

// Labels
import {
    LB_AIRLINE, LB_COMMENTS, LB_DATE, LB_DELIVER, LB_FLIGHT_HOUR,
    LB_FLIGHT_NUMBER, LB_INTERNATIONAL, LB_NATIONAL,
    LB_PEOPLE, LB_PICKUP, LB_PICKUP_HOUR, LB_TERMINAL, LB_WL_ACTIVITY, REQUIRED
} from "../../i18n/i18n";
import {FL_AIRPORT} from "../../i18n/formLabels";

// utilis
import {formatStringDate, getDateToFormField} from "../../../util/DateTools";

// actions
import { add } from "../../../redux/actions/todoFluye/wishlistActions";

// providers
import { airlineProvider } from "../../../providers/airlineProvider";
import {wishlistTypes} from "../../../util/WishlistUtils";
import {airportProvider} from "../../../providers/hotel/airportProvider";
import {terminalProvider} from "../../../providers/hotel/terminalProvider";
import DependentCustomSelect from "../../select/DependentCustomSelect";

const TransportationFormComponent = props => {
    const fbDataBaseId = props.mainState?.app?.fbDataBase?.id
    const { domainObject } = props.formState
    const { wishlist, handleCancel, handleToggle  } = props

    const [ editMode ] = useState(domainObject != null)

    const [pickupDeliver, setPickupDeliver] = useState( domainObject ? domainObject?.pickupDeliver : true)
    const [isNational, setIsNational] = useState( domainObject ? domainObject?.isNational : true)
    const [airline, setAirline] = useState(domainObject?.airline?.id)
    const [airlineError, setAirlineError] = useState(false)

    const [airport, setAirport] = useState(domainObject?.airport?.id || null);
    const [airportError, setAirportError] = useState(false);

    const [terminal, setTerminal] = useState(domainObject?.terminal?.id || null);
    const [terminalError, setTerminalError] = useState(false);

    const validationSchema = Yup.object().shape({
        date: Yup.string().required( REQUIRED ),
        hour: Yup.string().required( REQUIRED ),
        pickupHour: Yup.mixed().test('pickupHour', REQUIRED, value => {
            if(!pickupDeliver)
                return !!value

            return true
        }),
        flightNumber: Yup.string().required( REQUIRED ),
        pax: Yup.string().required( REQUIRED ),
    });

    const { register, handleSubmit, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues:{
            date: domainObject ? formatStringDate(domainObject?.date) : null,
            hour: domainObject?.hour,
            flightNumber: domainObject?.flightNumber,
            pax: domainObject?.pax,
            comments: domainObject?.comments,
            confirmationCode: domainObject?.confirmationCode,
            pickupHour: domainObject?.pickupHour,
        }
    });

    const onSubmit = (data, _) => {
        let hasError = false
        if(!airport){
            setAirportError(true)
            hasError = true;
        }

        if(!airline){
            setAirlineError(true)
            hasError = true;
        }

        if(!terminal){
            setTerminalError(true)
            hasError = true;
        }

        if(hasError)
            return

        let dataRequest = {
            fbDataBase: fbDataBaseId,
            item: {
                ... data,
                type: wishlistTypes.transportation.description,
                wishlist:{ id:wishlist?.id },
                pickupDeliver,
                isNational,
                status:'CONFIRMED',
                from:'wishlist',
                airline: {
                    id: airline
                },
                airport: {
                    id: airport
                },
                terminal: {
                    id: terminal
                }
            }
        }

        if(pickupDeliver)
            dataRequest.item.pickupHour = data?.hour

        if(domainObject)
            dataRequest.item.id = domainObject?.id

       props.add( dataRequest, handleToggle )
    }

    const handleAirlineChange = value => {
        setAirline( value )
        setAirlineError(!value)
    }

    const handleAirportChange = value => {
        setAirport( null )
        setAirport( value )
        setAirportError(!value)
    }

   const handleTerminalChange = value => {
        setTerminal( value )
        setTerminalError(!value)
   }

    return <Form  onSubmit={handleSubmit(onSubmit)}>
        <FormGroup tag="fieldset">
            <Row className={'mb-2em'}>
                <Col className={'wl-modal-title-item fex-center'}>
                    <img
                        src={require(`../../../assets/images/wishlist/${props?.selectedOption?.icon}`)}
                        alt={LB_WL_ACTIVITY}
                        width={36}
                        height={36}
                    /> &nbsp; { props?.selectedOption?.title }
                </Col>

            </Row>

            <Row className={'mb-1em'}>
                <Col>
                    <FormGroup>
                        <label>
                            <i className={ 'fa fa-calendar' } aria-hidden='true' /> &nbsp;{ LB_DATE }
                        </label>
                        <Input
                            name='date'
                            type="date"
                            innerRef={register}
                            min={ getDateToFormField(wishlist?.checkIn) }
                            max={ getDateToFormField(wishlist?.checkOut) }
                        />
                        { errors?.date && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.date?.message}</div>}
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <label>
                            <i className={ 'fa fa-clock' } aria-hidden='true' /> &nbsp;{ LB_FLIGHT_HOUR }
                        </label>
                        <Input type="time" name='hour' innerRef={register} />
                        { errors?.hour && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.hour?.message}</div>}
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <label>
                            <i className={ 'fa fa-users' } aria-hidden='true' /> &nbsp;{ LB_PEOPLE }
                        </label>
                        <Input
                            type="number"
                            name='pax'
                            min={1}
                            innerRef={register}
                        />
                        { errors?.pax && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.pax?.message}</div>}
                    </FormGroup>
                </Col>
            </Row>


            <div className={'mb-1em'}>
                <DependentCustomSelect
                    mainTitle={ FL_AIRPORT }
                    mainProvider={ airportProvider }
                    onChangeMain={ handleAirportChange }
                    mainError={{
                        hasError: airportError,
                        message: REQUIRED
                    }}

                    secondaryTitle={ LB_TERMINAL }
                    secondaryProvider={ terminalProvider }
                    onChangeSecondary={ handleTerminalChange }
                    secondaryError={{
                        hasError: terminalError,
                        message: REQUIRED
                    }}
                    secondaryFilters={{
                        item:{ airport: {id: airport} }
                    }}
                />
            </div>


            <Row className={'mb-1em'}>
                <Col>
                    <Label>
                        <i className={ 'fa fa-plane' } aria-hidden='true' /> &nbsp;{ LB_AIRLINE }
                    </Label>
                    <FormGroup>
                        <SelectGeneric
                            initialValue={ airline }
                            setExternalValue={ handleAirlineChange }
                            provider={ airlineProvider }
                            isDisabled={ editMode }
                        />
                        { airlineError && <div className="invalid-feedback" style={{'display':'block'}}>{ REQUIRED }</div>}
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>
                            <i className={ 'fa fa-ticket' } aria-hidden='true' /> &nbsp;{ LB_FLIGHT_NUMBER }
                        </Label>
                        <Input type="text" name='flightNumber' innerRef={register} />
                        { errors?.flightNumber && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.flightNumber?.message}</div>}
                    </FormGroup>
                </Col>
            </Row>

            <Row className={'mb-1em'}>
                <Col>
                    <FormGroup>
                        <Label>{ LB_NATIONAL } / { LB_INTERNATIONAL }</Label>
                        <br/>
                        <Switch
                            animate={true}
                            onText={`${LB_NATIONAL}`}
                            offText={`${LB_INTERNATIONAL}`}
                            value={ isNational }
                            onChange={() => setIsNational(!isNational) }
                        />
                    </FormGroup>
                </Col>
                <Col>
                    <FormGroup>
                        <Label>{ LB_PICKUP } / { LB_DELIVER }</Label>
                        <br/>
                        <Switch
                            animate={true}
                            onText={`${LB_PICKUP}`}
                            offText={`${LB_DELIVER}`}
                            value={ pickupDeliver }
                            onChange={() => setPickupDeliver(!pickupDeliver) }
                        />
                    </FormGroup>
                </Col>

                {
                    !pickupDeliver && <Col>
                        <FormGroup>
                            <label>
                                <i className={'fa fa-clock'} aria-hidden='true'/> &nbsp;{LB_PICKUP_HOUR}
                            </label>
                            <Input type="time" name='pickupHour' innerRef={register}/>
                            {errors?.pickupHour && <div className="invalid-feedback" style={{'display': 'block'}}>{errors?.pickupHour?.message}</div>}
                        </FormGroup>
                    </Col>
                }
            </Row>

            <Row className={'mb-1em'}>
                <Col>
                    <FormGroup>
                        <Label>{ LB_COMMENTS }</Label>
                        <Input type="textarea" name='comments' innerRef={register} />
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col className="d-flex justify-content-center">
                    <div>
                        <ButtonSubmit/>
                        <ButtonCancel onClick={ ()=> handleCancel() }/>
                    </div>
                </Col>
            </Row>
        </FormGroup>
    </Form>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    formState: state.formProps
})
const mapActionsToProps = ({
    add
})

export default connect(mapStateToProps, mapActionsToProps)(TransportationFormComponent)